import { CDN_BASE_URL } from './constants';
import type { CdnResizeOptions } from './media.type.ts';

/** S3 key → 전체 CDN URL. 앞 슬래시 중복 방지 */
export function cdnUrl(key: string): string {
  if (!CDN_BASE_URL) {
    throw new Error('[media] VITE_CDN_BASE_URL is not defined');
  }
  return `${CDN_BASE_URL}/${key.replace(/^\/+/, '')}`;
}

/**
 * 리사이즈 옵션이 붙은 URL.
 * CloudFront 리사이즈 함수 붙기 전엔 쿼리가 무시되고 원본이 내려온다(무해).
 * 인프라 붙으면 여기 파라미터명(w/h/q/f)만 실제 스펙에 맞추면 됨.
 */
export function cdnImageUrl(key: string, opts: CdnResizeOptions = {}): string {
  const url = cdnUrl(key);
  const params = new URLSearchParams();
  if (opts.width) params.set('w', String(opts.width));
  if (opts.height) params.set('h', String(opts.height));
  if (opts.quality) params.set('q', String(opts.quality));
  if (opts.format) params.set('f', opts.format);

  const qs = params.toString();
  return qs ? `${url}?${qs}` : url;
}

/** width 배열 → srcset 문자열 */
export function cdnSrcSet(key: string, widths: number[]): string {
  return widths.map((w) => `${cdnImageUrl(key, { width: w })} ${w}w`).join(', ');
}
